export default __webpack_public_path__ + "static/NewcastleBlackhawks-98597c2ff1fa3cf122a2e9bfc29a437b.jpg";